import React, { useState } from "react";
import "./Program.css";
import EnrollForm from "./Enroll";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const programList = [
  {
    title: "English Communication",
    description: "Enhance your spoken and written English skills for better opportunities.",
  },
  {
    title: "Short-term Computer Courses",
    description: "Basic to intermediate computer skills including MS Office, internet, and typing.",
  },
  {
    title: "Basic French",
    description: "Start your journey into the French language and culture with our foundation course.",
  },
];

const Programs = () => {
  const [selectedProgram, setSelectedProgram] = useState(null);

  const handleEnroll = (programName) => {
    setSelectedProgram(programName);
  };

  const handleClose = () => {
    setSelectedProgram(null);
  };

  const handleSubmit = () => {
    toast.success("Successfully Enrolled!");
    setSelectedProgram(null);
  };

  return (
    <div className="programs-page">
      <h1>Our Programs</h1>
      <p>Explore the educational and developmental programs offered by Navveer Foundation.</p>

      <div className="programs-grid">
        {programList.map((program, idx) => (
          <div className="program-card" key={idx}>
            <h3>{program.title}</h3>
            <p>{program.description}</p>
            <button onClick={() => handleEnroll(program.title)}>Enroll Now</button>
          </div>
        ))}
      </div>

      {selectedProgram && (
        <EnrollForm
          program={selectedProgram}
          onClose={handleClose}
          onSubmit={handleSubmit}
        />
      )}

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default Programs;
